import { render, staticRenderFns } from "./ResizableTextArea.vue?vue&type=template&id=2ea38212&"
import script from "./ResizableTextArea.vue?vue&type=script&lang=js&"
export * from "./ResizableTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports